import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import ButtonLogin from './buttonLogin'
import { ButtonsLoginWrapper } from './index.styled'
import { useDispatch } from 'react-redux'
import { isLocalStorageMobileAppMode } from '../../../helper/mode'
import { setLoginFailedWithStorageThunk } from '../../../redux/thunk/registration/auth/withStorage'

const ButtonsLogin = () => {
	const navigate = useNavigate()
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const isMobileApp = isLocalStorageMobileAppMode()

	const navigateToLogin = () => {
		dispatch(setLoginFailedWithStorageThunk())
		navigate('/login')
	}
	const navigateToRegister = () => {
		dispatch(setLoginFailedWithStorageThunk())
		navigate('/registration')
	}

	return (
		<ButtonsLoginWrapper>
			<ButtonLogin text={t('Login.Login')} onClick={navigateToLogin} />
			{!isMobileApp &&
				<ButtonLogin text={t('Registration.Owner.Register')} isBorder onClick={navigateToRegister} />}
		</ButtonsLoginWrapper>
	)
}

ButtonsLogin.displayName = 'ButtonsLogin'
export default ButtonsLogin
